import type { DateString, SortDirection } from "@/types/common"
import type { Exam, ExamsList } from "@/types/exam"
import { API_ROOT, HttpClient } from "@/api/httpClient"
import { dPayload } from "@/utils/dayjs"
import reports from "./reports"

export type ExamsListSortKey = "date"

export interface ExamsListQuery {
	perPage: number
	page: number
	sort?: {
		key?: ExamsListSortKey
		direction?: SortDirection
	}
	filters?: {
		/** cerca in: sintomi, note */
		text?: string
		dateFrom?: Date
		dateTo?: Date
	}
}

interface ExamsListParams {
	paginate: true
	per_page: number
	page: number
	sort_key?: ExamsListSortKey
	sort_dir?: SortDirection
	searchTerm?: string
	/** YYYY-MM-DD */
	dateFrom?: DateString
	/** YYYY-MM-DD */
	dateTo?: DateString
}

export interface ExamPayload {
	slug: string
	markers?: string[]
	notes?: string
}

export default {
	list(patientId: number, payload?: ExamsListQuery) {
		const params: ExamsListParams = {
			paginate: true,
			per_page: payload?.perPage || 50,
			page: payload?.page || 1,
			sort_dir: payload?.sort?.direction || "desc",
			sort_key: payload?.sort?.key || "date"
		}

		if (payload?.filters?.text !== undefined) {
			params.searchTerm = payload.filters.text
		}

		if (payload?.filters?.dateFrom !== undefined && payload?.filters?.dateTo !== undefined) {
			params.dateFrom = dPayload(payload.filters.dateFrom, "date")
			params.dateTo = dPayload(payload.filters.dateTo, "date")
		}

		return HttpClient.get<ExamsList>(`${API_ROOT}/patients/${patientId}/exams`, {
			params
		})
	},
	create(patientId: number, payload: ExamPayload) {
		return HttpClient.post<Exam>(`${API_ROOT}/patients/${patientId}/exams`, payload)
	},
	update(patientId: number, examId: number, payload: ExamPayload) {
		return HttpClient.put(`${API_ROOT}/patients/${patientId}/exams/${examId}`, payload)
	},
	details(patientId: number, examId: number) {
		return HttpClient.get<Exam>(`${API_ROOT}/patients/${patientId}/exams/${examId}`)
	},
	delete(patientId: number, examId: number) {
		return HttpClient.delete(`${API_ROOT}/patients/${patientId}/exams/${examId}`)
	},
	reports
}
